import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
type Testimonial = {
  initials: string;
  name: string;
  city: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'Martina G.',
  city: 'Rosario',
  quote: 'Venía operando hace dos años sin estructura ninguna. Con el módulo 1 empecé a entender por qué tomaba las decisiones que tomaba. Eso solo ya cambió todo.'
}, {
  initials: 'LF',
  name: 'Lucas F.',
  city: 'Córdoba',
  quote: 'No esperaba que algo tan simple como el Framework de revisión me ayudara a no perder el hilo en medio de una jornada. Lo apliqué desde el primer día.'
}, {
  initials: 'VR',
  name: 'Valentina R.',
  city: 'Santa Fe',
  quote: 'Leí la primera estrategia y la entendí al toque. La puse en práctica con papel y lápiz antes de usar dinero real.'
}, {
  initials: 'EM',
  name: 'Ezequiel M.',
  city: 'Tucumán',
  quote: 'Lo que más me gustó es que no te venden magia. Te dan estructura y te hacen pensar.'
}, {
  initials: 'NB',
  name: 'Natalia B.',
  city: 'Mar del Plata',
  quote: 'Hice el backtesting de la segunda estrategia como sugieren y fue muy revelador. Te obliga a ser honesto con vos mismo.'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-257" data-mp="79le7elc2v7t">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand text-brand" data-id="element-258" data-mp="c8ok119515gu" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <Section className="border-y border-white/5 bg-ink-900" data-id="element-259" data-mp="14v9b00lpbfjv">
      <Reveal data-id="element-260" data-mp="14ura2qo3gd5m">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-261" data-mp="14xdckbw4o2gz">
          Personas que ya empezaron el camino
        </h2>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-262" data-mp="v3d17sa960zt">
        {testimonials.map((t, i) => <Reveal key={t.initials} delay={i * 0.05} className={i === testimonials.length - 1 ? 'sm:col-span-2' : ''} data-id="element-263" data-mp="1itz9nko65nac" data-mpi={i}>
            <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-264" data-mp="1nnv6gjsp543x">
              <div className="flex items-center gap-3" data-id="element-265" data-mp="1siwfoo24o6af">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full border border-brand/30 bg-brand-soft font-display text-sm font-bold text-brand" data-id="element-266" data-mp="1sjfn3au5jca7">
                  {t.initials}
                </span>
                <div data-id="element-267" data-mp="1jkke5qzq3o37">
                  <figcaption className="text-sm font-semibold text-white" data-id="element-268" data-mp="1ejodrnekyk2j">
                    {t.name}
                  </figcaption>
                  <p className="text-xs text-gray-500" data-id="element-269" data-mp="19rmv9jqtjx42">{t.city}</p>
                </div>
                <div className="ml-auto" data-id="element-270" data-mp="14ud707f61rht">
                  <Stars data-id="element-271" data-mp="14qz48y2lbg9u" />
                </div>
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-gray-300" data-id="element-272" data-mp="10t1hs307f8a5">
                “{t.quote}”
              </blockquote>
            </figure>
          </Reveal>)}
      </div>
    </Section>;
}